import {
  EAvailabilityState,
  EFreightLoadingType,
  EStopType,
  EVehicleType,
  IFreightAvailable,
  IFreightAvailableDetailed,
  IStopAddressFreightAvailable,
  IStopFreightAvailable,
} from '@okcargo-apps/shared-domain';
import {
  AvailabilityState,
  FreightMarketDetailForCarrierResponse,
  FreightMarketForCarrierResponse,
} from '@okcargo/query-processor';

export function mapBaseFreight(
  dto: FreightMarketForCarrierResponse | FreightMarketDetailForCarrierResponse,
): IFreightAvailable {
  const stops: IStopFreightAvailable[] = dto.stops.map((stopResponse) => {
    const stopAddress: IStopAddressFreightAvailable = {
      city: stopResponse.city,
      postalCode: stopResponse.postalCode,
      stateCode: stopResponse.stateCode,
      countryCode: stopResponse.countryCode,
      // coords: stop.address.coords,
    };

    const stop: IStopFreightAvailable = {
      address: stopAddress,
      id: stopResponse.id,
      position: stopResponse.position,
      type: stopResponse.type as unknown as EStopType, // TODO map to EStopType enum
      since: stopResponse.since ? new Date(stopResponse.since) : null,
      until: stopResponse.until ? new Date(stopResponse.until) : null,
    };

    return stop;
  });

  const pricePerKilometer = dto.distance > 0 ? Math.round((dto.price / dto.distance) * 100) / 100 : 0;

  return {
    stops,
    pricePerKilometer,
    id: dto.id,
    reference: dto.reference,
    vehicleTypes: dto.vehicleTypes as unknown as EVehicleType[], // TODO map to EVehicleType enum
    loadingTypes: dto.loadingTypes as unknown as EFreightLoadingType[], // TODO map to EFreightLoadingType enum
    weight: dto.weight,
    distance: dto.distance,
    price: dto.price,
    available: mapAvailabilityState(dto.available),
  };
}

export function transformToIFreightAvailableList(dtos: FreightMarketForCarrierResponse[]): IFreightAvailable[] {
  return dtos.map(mapBaseFreight);
}

export function transformToIFreightAvailableDetailed(
  dto: FreightMarketDetailForCarrierResponse,
): IFreightAvailableDetailed {
  return {
    ...mapBaseFreight(dto),
    instructions: dto.instructions ?? undefined,
  };
}

function mapAvailabilityState(state: AvailabilityState): EAvailabilityState {
  switch (state) {
    case AvailabilityState.NO:
      return EAvailabilityState.NO;
    case AvailabilityState.PARTIAL:
      return EAvailabilityState.PARTIAL;
    case AvailabilityState.FULL:
      return EAvailabilityState.FULL;
  }
}
